import { AppInsightsContext } from "@microsoft/applicationinsights-react-js";
import React from "react";
import { attachStore } from "./src/attach-store";
import { AuthWithLD } from "./src/auth/auth.component";
import { ApplicationFormAuthWithLD } from "./src/auth/application/application-auth.component";
import { isDebugMode } from "./src/shared/config.utils";
import { reactPlugin, appInsights } from "./src/shared/insights/app-insights";
import { isBrowser } from "@wisr/common";
import * as amplitude from "@amplitude/analytics-browser";

appInsights.loadAppInsights();
export const wrapPageElement = ({ element, props }) => {
  appInsights.trackPageView();
  const isApplication =
    element.key == "/application/*" ||
    element.key == "/application/post-submission/";

  return (
    <AppInsightsContext.Provider value={reactPlugin}>
      {isApplication ? (
        <ApplicationFormAuthWithLD {...props}>
          {element}
        </ApplicationFormAuthWithLD>
      ) : (
        <AuthWithLD {...props}>{element}</AuthWithLD>
      )}
    </AppInsightsContext.Provider>
  );
};

export const wrapRootElement = attachStore;

export const registerServiceWorker = () => true;

export const onClientEntry = () => {
  if (isDebugMode()) {
    registerServiceWorker();
  }
};

if (isBrowser()) {
  window.amplitude = amplitude;

  // Shim so old logEvent calls still work
  window.amplitude.getInstance = function () {
    return {
      logEvent: function (eventName, eventProps) {
        amplitude.track(eventName, eventProps);
      },
      setUserId: function (userId) {
        amplitude.setUserId(userId);
      },
      setUserProperties: function (props) {
        const identifyObj = new amplitude.Identify();
        Object.entries(props).forEach(([key, value]) =>
          identifyObj.set(key, value)
        );
        amplitude.identify(identifyObj);
      },
    };
  };
}
